var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('loading-overlay',{staticClass:"animated fadeIn"}):_c('div',{staticClass:"animated fadeIn"},[_c('default-heading',{staticClass:"mt-3"},[_vm._v("Orders")]),(_vm.invoices)?_c('invoice-server-table',{attrs:{"invoices":_vm.invoices}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }